import {Injectable} from '@angular/core';
import {AbstractSaveOneService} from '../../../../../core/service/v2/service/save/abstractSaveOne.service';
import {Scanner3dAccountModel} from '../../api/entity/scanner3dAccount.model';
import {Scanner3dAccountRepository} from './ngrx/scanner3dAccount.repository';
import {Scanner3dAccountDataServiceAdapter} from './ngrx/scanner3dAccountDataService.adapter';
import {Scanner3dAccountSavePayload} from './payload/scanner3dAccountSave.payload';


@Injectable()
export class Scanner3dAccountSaveService extends AbstractSaveOneService<Scanner3dAccountModel, Scanner3dAccountSavePayload> {

    constructor(repository: Scanner3dAccountRepository, dataServiceAdapter: Scanner3dAccountDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
